<template>
    <rkm-overlay>
        <rkm-layout-body title="Atendimento médico">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/pronto-atendimento/atendimento-medico/List'

export default {
    components: { List },
}
</script>